import {
  CheckboxIndicator as CheckboxPrimitiveIndicator,
  Root as CheckboxPrimitiveRoot,
  type CheckboxProps,
} from "@radix-ui/react-checkbox";

import { Check } from "@/components/ui/Icons";
import { cn } from "@/lib/utils";

const Checkbox = ({ checked, ...props }: CheckboxProps) => (
  <CheckboxPrimitiveRoot
    checked={checked}
    {...props}
    className={cn(
      "w-4 h-4 border rounded min-w-[1rem] min-h-[1rem] items-center flex",
      {
        "border-secondary bg-white": !checked && !props.disabled,
        "border-transparent bg-button-primary": checked && !props.disabled,
        "border-secondary bg-button-disabled": props.disabled,
      },
    )}
  >
    <CheckboxPrimitiveIndicator asChild>
      <Check
        strokeWidth={2.5}
        size={16}
        className={props.disabled ? "stroke-disabled" : "stroke-white"}
      />
    </CheckboxPrimitiveIndicator>
  </CheckboxPrimitiveRoot>
);

export { Checkbox };
